import React from 'react'
import { useNavigate } from 'react-router-dom';
import { Modal } from 'react-bootstrap'

function SessionFun(props) {
    const navigate = useNavigate();
    function sessionExpire()
    {
        sessionStorage.clear();
        navigate('/login');
    }

    return (
        <div>
            <Modal show={props.show} centered backdrop="static" size="sm">
                <Modal.Header>
                    <Modal.Title>Session Timeout</Modal.Title>
                </Modal.Header>
                <Modal.Body className='text-center logout-box'>
                    <p><b>Your session has been expired! Please login again.</b></p>
                    <button className="btn btn-light confirm-btn" onClick={sessionExpire}>
                        Ok
                    </button>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default SessionFun
